module.exports = __webpack_public_path__ + "media/icons/government-34ff3d01.png";